import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { Eye, X } from 'lucide-react';

/**
 * Banner that pins to the top whenever the current session is impersonating
 * another user. Surfaces who is being impersonated, who launched it, and a
 * one-click "Stop impersonating" that just clears localStorage and reloads.
 */
export default function ImpersonationBanner() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/manage/impersonate/status`);
        if (!cancelled) setStatus(res.data || null);
      } catch (e) {
        if (!cancelled) setStatus(null);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!status?.impersonating) return null;

  const stop = () => {
    // Restore the admin's previous token if we stashed it
    const previous = localStorage.getItem('impersonate_previous_token');
    if (previous) {
      localStorage.setItem('token', previous);
      localStorage.removeItem('impersonate_previous_token');
    } else {
      localStorage.removeItem('token');
    }
    window.location.href = '/admin/audit';
  };

  return (
    <div className="bg-amber-50 dark:bg-amber-900/30 border-b border-amber-200 dark:border-amber-800 text-amber-800 dark:text-amber-200 px-4 py-2 text-xs flex items-center gap-3" data-testid="impersonation-banner">
      <Eye className="w-3.5 h-3.5 flex-shrink-0" />
      <span>
        <strong>Impersonating</strong> — read-only session, launched by{' '}
        <strong>{status.impersonator?.name || 'admin'}</strong> ({status.impersonator?.role}).
      </span>
      <button
        onClick={stop}
        className="ml-auto inline-flex items-center gap-1 px-2.5 py-1 rounded-md border border-amber-300 dark:border-amber-700 hover:bg-amber-100 dark:hover:bg-amber-900/50 font-medium"
        data-testid="stop-impersonating-btn"
      >
        <X className="w-3 h-3" /> Stop impersonating
      </button>
    </div>
  );
}
